import { useCallback as f } from "react";
import { getNumericValue as t } from "../helpers.js";
const p = (r, n, u, c, l) => {
  const a = f((m) => (o) => {
    if (o.preventDefault(), r.current) {
      const s = parseFloat(r.current.value), i = t(n);
      let e;
      if (m === "increment") {
        if (e = s + i, e > t(c))
          return;
      } else if (m === "decrement" && (e = s - i, e < t(u)))
        return;
      r.current.value = String(e), l?.(String(e));
    }
  }, [n, u, c, l]);
  return {
    handleIncrement: a("increment"),
    handleDecrement: a("decrement")
  };
};
export {
  p as useAdjustValue
};
